import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Walls extends Component {
  render() {
    return (
      <EntityList apiRoute='api/walls' title='Remorque - Murs' editTitle='Mur' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Walls;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/walls.js
 **/